'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Profile = undefined;

var _Profile2 = require('./Profile');

var _Profile3 = _interopRequireDefault(_Profile2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Profile = _Profile3.default;


//////////////////
// WEBPACK FOOTER
// ./src/containers/Personal/Profile/index.js
// module id = 1836
// module chunks = 0